/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://uxexmkjudnhelia2u2fgse5w4u.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-hg6oejjyubakxn4h2jxl2lv4fi",
    "aws_cognito_identity_pool_id": "us-east-1:144435cc-d8c5-41c4-9e0b-1b7062660a83",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ZjWnsbXJX",
    "aws_user_pools_web_client_id": "12b8oa7bloa6i1qprsohhtr427",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tina-waters-artist-storage-f63cc07e22044-deploy",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
